export default {
  apiKey: 'AIzaSyBq3T3PmKPL7bCYGPWxhDttM_YjL1JBmNk',
  authDomain: 'talk-to-santa.firebaseapp.com',
  databaseURL: 'https://talk-to-santa.firebaseio.com',
  projectId: 'talk-to-santa',
  storageBucket: 'talk-to-santa.appspot.com',
  messagingSenderId: '184757471003',
  appId: '1:184757471003:web:9a78f33ce4add8369e75be',
  measurementId: 'G-98RDWM8SG1',
};
